// 短信服务相关接口
import request from '@/plugin/axios'

// 获取短信余量信息
export function getSurplusLog (params) {
  return request({
    url: '/sms/operation/log/surplus',
    method: 'get',
    params
  })
}
// 修改余额提醒值
export function postRemindLog (data) {
  return request({
    url: '/sms/operation/log/remind',
    method: 'post',
    data
  })
}

// 获取今日统计数据
export function getTodayStatistics (params) {
  return request({
    url: '/sms/operation/log/today/statistics',
    method: 'get',
    params
  })
}

// 获取今日发送记录
export function getTodayLog (params) {
  return request({
    url: '/sms/operation/log/today',
    method: 'get',
    params
  })
}

// 获取短信单价
export function getPrice () {
  return request({
    url: '/sms/system/price/getPrice'
  })
}

// 短信充值下单
export function applyRecharge (data) {
  return request({
    url: '/sms/operation/recharge/applyRecharge',
    method: 'post',
    data
  })
}

// 上传短信充值凭证
export function uploadVoucher (data) {
  return request({
    url: '/sms/operation/recharge/uploadVoucher',
    method: 'post',
    data
  })
}

// 获取充值记录
export function getRechargeList (params) {
  return request({
    url: '/sms/operation/recharge/pageList',
    method: 'get',
    params
  })
}

// 获取统计报告
export function getStatistics (params) {
  return request({
    url: '/sms/operation/log/history/statistics',
    method: 'get',
    params
  })
}

// 获取发送记录
export function getSendHistory (params) {
  return request({
    url: '/sms/operation/log/history',
    method: 'get',
    params
  })
}

// 短信重发
export function smsRepeat (logIds) {
  return request({
    url: '/sms/operation/log/smsRepeat',
    method: 'post',
    data: {
      logIds
    }
  })
}

// 短信套餐-获取套餐选项
export function getPackageOptions (params) {
  return request({
    url: '/sms/operation/package/option',
    method: 'get',
    params
  })
}

// 短信套餐-套餐购买
export function packageRecharge (data) {
  return request({
    url: '/sms/operation/package/purchase',
    method: 'post',
    data
  })
}

// 自定义短信-选择人员-获取赛事列表
export function getMatchList (params) {
  return request({
    url: '/sms/operation/custom/matchOption',
    method: 'get',
    params
  })
}

// 自定义短信-选择人员-获取鸽主（人员）列表
export function getPersonnelList (params) {
  return request({
    url: '/sms/operation/custom/ownerPage',
    method: 'get',
    params
  })
}

// 自定义短信-获取导入的手机号
export function getImportPhones (params) {
  return request({
    url: `/sms/operation/custom/importedMobile/${params}`,
    method: 'post'
  })
}

// 自定义短信-自定义短信-短信内容校验
export function verifyMessage (data) {
  return request({
    url: '/sms/operation/custom/verifySmsContent',
    method: 'post',
    data
  })
}

// 自定义短信-短信发送
export function sendMessage (data) {
  return request({
    url: '/sms/operation/custom/send',
    method: 'post',
    data
  })
}

// 查询用户是否开通了短信服务
export function querySmsServiceStatus (params) {
  return request({
    url: '/sms/operation/log/getSmsOpen',
    method: 'get',
    params
  })
}


// 订单列表查询
export function queryOperationPage (params) {
  return request({
    url: '/shop/operation/order/queryOperationPage',
    method: 'get',
    params
  })
}
// 订单详情
export function queryOperationOrderInfo (params) {
  return request({
    url: '/shop/operation/order/queryOperationOrderInfo',
    method: 'get',
    params
  })
}


// 保存付款凭证
export function uploadOperationVoucher (data) {
  return request({
    url: '/shop/operation/order/uploadOperationVoucher',
    method: 'post',
    data
  })
}

// 修改订单备注
export function updateOperationRemark (data) {
  return request({
    url: '/shop/operation/order/updateOperationRemark',
    method: 'post',
    data
  })
}

// 发货记录列表
export function getOperationShippingRecordsInfo (params) {
  return request({
    url: '/shop/operation/shippingRecords/getOperationShippingRecordsInfo',
    method: 'get',
    params
  })
}


// 审核列表
export function smsCustomReportPage (params) {
  return request({
    url: '/sms/operation/log/smsCustomReportPage',
    method: 'get',
    params
  })
}


// 审核失败的任务
export function handleTask (params) {
  return request({
    url: '/sms/operation/log/handleTask',
    method: 'get',
    params
  })
}


// 获取手机号数量
export function getMobileCount (params) {
  return request({
    url: '/sms/operation/mobile/getMobileCount',
    method: 'get',
    params
  })
}
// 手机号详情分页
export function mobilePageList (params) {
  return request({
    url: '/sms/operation/mobile/mobilePageList',
    method: 'get',
    params
  })
}
// 清空手机号
export function removeAll (params) {
  return request({
    url: '/sms/operation/mobile/removeAll',
    method: 'get',
    params
  })
}
// 删除单个手机号
export function deleteMobile (params) {
  return request({
    url: '/sms/operation/mobile/deleteMobile',
    method: 'get',
    params
  })
}
// 获取发送结果
export function getSendResult (params) {
  return request({
    url: '/sms/operation/custom/getSendResult',
    method: 'get',
    params
  })
}
// 手动输入保存
export function inputMobile (data) {
  return request({
    url: '/sms/operation/mobile/inputMobile',
    method: 'post',
    data
  })
}
// 人员选择保存
export function selectMobile (data) {
  return request({
    url: '/sms/operation/mobile/selectMobile',
    method: 'post',
    data
  })
}
// 验证短信是否重复
export function verifyDuplicateSend (data) {
  return request({
    url: '/sms/operation/custom/verifyDuplicateSend',
    method: 'post',
    data
  })
}